import init from './init';
// import staffPortal from './pages/staff-portal';
import headerSection from "./section/header";
import popup from "./section/popup";
init();
headerSection();
popup();
// staffPortal();



// WEBPACK FOOTER //
// ./source/scripts/main.js